import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { RouterService } from '../service/router.service';
import { Game } from '../enum/game.enum';
import { inject } from '@angular/core';

export const gameInitializer: ResolveFn<void> = (
  route: ActivatedRouteSnapshot,
) => {
  if (route.data['game']) {
    inject(RouterService).init(route.data['game'] as Game);
  }
};
